import { render } from "./CreateFolderModal.vue?vue&type=template&id=2f8c1f84"
import script from "./CreateFolderModal.vue?vue&type=script&lang=js"
export * from "./CreateFolderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__